import React from "react";
import styles from "./OfferTableRow.module.css";
import classnames from "classnames";
import {OfferInListDTO, OfferStatus} from "../../../../../api/generated";
import {OfferTypeCard} from "../../../../elements/offerTypeCard/OfferTypeCard";
import {OfferTitleCell} from "./cell/offerTitle/OfferTitleCell";
import {MakeModelCell} from "./cell/makeModel/MakeModelCell";
import {StartEndDateCell} from "./cell/startEndDate/StartEndDateCell";
import {OfferValueCell} from "./cell/offerValue/OfferValueCell";
import {OfferSourceCell} from "./cell/offerSource/OfferSourceCell";
import {OfferActions} from "./cell/offerActions/OfferActions";

interface TranscriptTableRowProps {
    index: number
    offer: OfferInListDTO
    isLastRow: boolean
}

export const OfferTableRow: React.FC<TranscriptTableRowProps> = ({index, offer, isLastRow}) => {

    const isArchived = offer.offerStatus === OfferStatus.Archived;

    return <div key={index} className={classnames(
        styles.wrapper,
        isLastRow && styles.lastRow,
        isArchived && styles.archivedRow
    )}>
        <OfferTitleCell offer={offer}/>
        <span className={styles.typeCell}><OfferTypeCard offerType={offer.offerType}/></span>
        <MakeModelCell offer={offer}/>
        <StartEndDateCell offer={offer}/>
        <OfferValueCell offer={offer}/>
        <OfferSourceCell offer={offer}/>
        <OfferActions
            index={index}
            offer={offer}
        />
    </div>
}
